module.exports = __webpack_public_path__ + "static/img/inverter.d47c928.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/inverter.png
// module id = 223
// module chunks = 1